import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiTooltipModule } from "../tooltip/tooltip.module";
import { UiPopoverComponent } from "./popover.component";
import { UiPopoverDirective } from "./popover.directive";

@NgModule({
  imports: [CommonModule, OverlayModule, UiTooltipModule],
  declarations: [UiPopoverDirective, UiPopoverComponent],
  exports: [UiPopoverDirective, UiPopoverComponent],
})
export class UiPopoverModule {}
